import { isDate } from 'date-fns';
import { LocalDate, Today, isBefore, isSameDay } from 'lib/localDate';
import { createSelector } from 'reselect';
import { createSearchQuerySelector } from 'lib/search/createQuerySelector';
import createSearchQueryString from 'lib/search/createSearchQueryString';
import { getPropertyId, getPropertyLocation } from 'store/property/propertySelectors';
import { getQueryParams } from 'store/router/routerSelectors/getQueryParams';

export const getQuery = createSearchQuerySelector(getQueryParams);

export const getQueryAdults = createSelector(getQuery, (query) => query.adults);
export const getQueryChildren = createSelector(getQuery, (query) => query.children);
export const getQueryInfants = createSelector(getQuery, (query) => query.infants);

export const getQueryCheckIn = createSelector(getQuery, (query) => query.checkIn);
export const getQueryCheckOut = createSelector(getQuery, (query) => query.checkOut);

export const getQueryClassicRewards = createSelector(getQuery, (query) => query.classicRewards);
export const getQueryDepositPay = createSelector(getQuery, (query) => query.depositPay);
export const getQueryFreeCancellation = createSelector(getQuery, (query) => query.freeCancellation);
export const getQueryFeaturedOfferId = createSelector(getQuery, (query) => query.featuredOfferId);
export const getQueryPayWith = createSelector(getQuery, (query) => query.payWith);

export const getCheckoutLinkQueryString = createSelector(
  getQueryCheckIn,
  getQueryCheckOut,
  getQueryAdults,
  getQueryChildren,
  getQueryInfants,
  getQueryPayWith,
  (checkIn, checkOut, adults, children, infants, payWith) =>
    createSearchQueryString({ checkIn, checkOut, adults, children, infants, payWith }),
);

export const getSearchLinkQuery = createSelector(getQuery, getPropertyLocation, (query, propertyLocation) => {
  const location = query.location || propertyLocation;
  return { ...query, location };
});

const hasValidCheckInDate = (query) => {
  // we had an issue where crawlers don't respect route changes. This is causing the property
  // page to fetch availability with invalid dates.
  if (!isDate(query.checkIn)) return false;

  const checkIn = LocalDate.fromDate(query.checkIn);

  return isBefore(Today(), checkIn) || isSameDay(Today(), checkIn);
};

export const getHasValidQuery = createSelector(getPropertyId, getQuery, (propertyId, query) => {
  return !!propertyId && hasValidCheckInDate(query) && !!query.checkOut && query.adults > 0;
});
